export default "__VITE_ASSET__e1aaba48__"